import { Directive, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';

// global lightGallery and plugin variables
declare var lightGallery: any;
declare var lgZoom: any;
declare var lgThumbnail: any;
declare var lgFullscreen: any;

@Directive({
  selector: '[appLightgallery]'
})
export class LightgalleryDirective implements AfterViewInit, OnDestroy {
  @Input() galleryOptions: any;
  private gallery: any;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    // make sure plugins are defined globally (from scripts in angular.json)
    const plugins = [];
    if (typeof lgZoom !== 'undefined') plugins.push(lgZoom);
    if (typeof lgThumbnail !== 'undefined') plugins.push(lgThumbnail);
    if (typeof lgFullscreen !== 'undefined') plugins.push(lgFullscreen);

    this.gallery = lightGallery(this.el.nativeElement, {
      selector: 'li',  // match your HTML structure
      plugins: plugins,
      ...this.galleryOptions
    });
  }

  ngOnDestroy(): void {
    if (this.gallery) {
      this.gallery.destroy();
    }
  }
}
